
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CommonLoading from './CommonLoading.vue';
import { getHomeTargetChart } from '@/apis/index';
import { AJAX_STATUS } from '@/config/config';
/* eslint-disable */
@Component({
  components: {
    CommonLoading,
  },
})
export default class CommonTargetChart extends Vue {
  // 传递的是展示的数组
  @Prop() private queryInfo!: any;
  beginDate = '';
  endDate = '';
  ajaxStatus = AJAX_STATUS.loading;
  myChart: any = null;
  chartData: any = null;
  // 获取图表高度的定时器
  getChartHightTimeout: any = null;
  @Watch('queryInfo', { immediate: false, deep: true })
  onQueryInfoChanged() {
    this.chartData = null;
    this.initChart();
  }
  initChart() {
    const chartDom = this.$refs.targetchart as HTMLElement;
    if (!chartDom.clientHeight) {
      return;
    }
    if (!this.myChart) {
      // 初始化
      this.myChart = window.ThsDataVStandardChart.init(chartDom, 'mobile-app-light');
      this.formatChartLine();
    }
    if (this.chartData) {
      this.setOption();
      return;
    }
    // 获取接口数据
    this.getData();
  }
  getData() {
    const { end, nodata } = AJAX_STATUS;
    getHomeTargetChart(this.queryInfo)
      .then(res => {
        // 获取数据
        if (res.statusCode === 0) {
          if (res.data.list && res.data.list.length) {
            // 有数据
            this.initData(res);
          } else {
            // 无数据
            this.ajaxStatus = nodata;
          }
        } else {
          this.ajaxStatus = end;
        }
      })
      .catch(() => {
        this.ajaxStatus = end;
      });
  }
  initData(res) {
    this.ajaxStatus = AJAX_STATUS.nomore;
    this.chartData = res.data.list.map((item, index) => this.handleChartData(res, item, index));
    this.beginDate = this.chartData[0].date;
    this.endDate = this.chartData[this.chartData.length - 1].date;
    this.setOption();
  }
  handleChartData(res, item, index) {
    if (index !== 0) {
      const beforeStock = res.data.list[index - 1].stockPrice ? res.data.list[index - 1].stockPrice : null;
      const beforeAvg = res.data.list[index - 1].avgPrice ? res.data.list[index - 1].avgPrice : null;
      item.stockPrice = item.stockPrice ? item.stockPrice : beforeStock;
      item.avgPrice = item.avgPrice ? item.avgPrice : beforeAvg;
    }
    item.date = item.date.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3');
    return item;
  }
  formatToolTip(params: any): string {
    const formatArray = [
      {
        label: '目标均价',
        color: '#FF9500',
      },
      {
        label: '最高目标价',
        color: 'transparent',
      },
      {
        label: '最低目标价',
        color: 'transparent',
      },
      {
        label: '股价',
        color: '#3366FF',
      },
    ];
    let templateStr = '';
    formatArray.forEach((item, index) => {
      let { value } = params[index];
      if (index === 1) {
        value = this.chartData[params[index].dataIndex].maxPrice;
      }
      if (index === 2) {
        value = this.chartData[params[index].dataIndex].minPrice;
      }
      value = value ? `${value.toFixed(2)}` : '--';
      templateStr += `<div class="targetecharts-tooltip-item flex ai-c jc-sb">
              <div class="flex ai-c jc-c"><span style="background-color: ${item.color}"></span>
              ${item.label}</div><p>${value}</p></div>`;
    });
    return `<div class="targetecharts-tooltip-date">${params[2].name}</div>${templateStr}`;
  }
  setOption() {
    const isDark = this.$isBlack;
    const dpr = this.$dpr;
    const that = this;
    const fontFamily = 'THS';
    const option = {
      tooltip: {
        trigger: 'axis',
        className: 'targetecharts-tooltip',
        backgroundColor: '#3b3b3b',
        formatter(params: any) {
          return that.formatToolTip(params);
        },
      },
      grid: {
        left: '1%',
        right: '1%',
        bottom: '0%',
        top: '2%',
        height: '89%',
      },
      xAxis: {
        type: 'category',
        data: that.chartData.map(function (item) {
          return item.date;
        }),
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          height: 14 * dpr,
          lineHeight: 14 * dpr,
          margin: 20 * dpr,
          formatter() {
            return '';
          },
        },
        boundaryGap: false,
        axisPointer: {
          type: 'line',
          animation: false,
          label: {
            show: true,
            backgroundColor: '#3366FF',
            margin: 4 * dpr,
            color: '#fff',
            fontSize: 10 * dpr,
            lineHeight: 10 * dpr,
            fontFamily,
            height: 10 * dpr,
            padding: [dpr, dpr, dpr, dpr],
          },
          z: 2,
          lineStyle: {
            color: `rgba(${isDark ? '255,255,255,0.08' : '0,0,0,0.6'})`,
            width: 1 * dpr,
            type: 'solid',
          },
        },
        z: 2,
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          fontSize: 10 * dpr,
          fontFamily,
          formatter(val: number) {
            return val ? `${val.toFixed(2)}` : '0';
          },
          align: 'left',
          color: `rgba(${isDark ? '255,255,255, 0.6' : '0,0,0,0.6'})`,
        },
        splitNumber: 3,
        splitLine: {
          lineStyle: {
            color: `rgba(${isDark ? '255,255,255,0.08' : '0,0,0,0.08'})`,
            width: 0.5 * dpr,
          },
        },
      },
      series: [
        {
          type: 'line',
          step: 'start',
          data: that.chartData.map(function (item) {
            return item.avgPrice;
          }),
          itemStyle: {
            color: '#ff9500',
          },
          showSymbol: true,
          lineStyle: {
            width: dpr,
          },
          label: {
            show: false,
          },
        },
        {
          name: 'U',
          step: 'start',
          type: 'line',
          data: that.chartData.map(function (item) {
            return item.minPrice;
          }),
          lineStyle: {
            opacity: 0,
          },
          label: {
            show: false,
          },
          stack: 'confidence-band',
          symbol: 'none',
        },
        {
          name: 'L',
          type: 'line',
          step: 'start',
          data: that.chartData.map(function (item) {
            return item.maxPrice - item.minPrice;
          }),
          lineStyle: {
            opacity: 0,
          },
          areaStyle: {
            color: '#ff9500',
            opacity: 0.15,
          },
          label: {
            show: false,
          },
          stack: 'confidence-band',
          symbol: 'none',
        },
        {
          type: 'line',
          data: that.chartData.map(function (item) {
            return item.stockPrice;
          }),
          itemStyle: {
            color: '#3366ff',
          },
          showSymbol: true,
          lineStyle: {
            width: 1.5 * dpr,
          },
          label: {
            show: false,
          },
        },
      ],
    };
    that.myChart.play({ option });
  }
  formatChartLine() {
    // 调整这三个：普通状态symbol的线宽，高亮状态symbol的线宽，高亮状态symbol的半径
    const dpr = this.$dpr;
    const NORMAL_LINE_WIDTH = dpr;
    const EMPHASIS_LINE_WIDTH = 1.5 * dpr;
    const SCALE = Math.sqrt(4) * dpr;
    const MAIN_SCALE = Math.sqrt(4.5) * dpr;
    // chart就是图表实例
    this.myChart.on('dv:afterupdate', () => {
      const ecIns = this.myChart.getECharts();
      const ecModel = ecIns.getModel();
      const lineSeriesModels = ecModel.getSeriesByType('line');
      lineSeriesModels.forEach((lineSeriesModel, index) => {
        if (index === 0 || index === 3) {
          const lineSeriesView = ecIns.getViewOfSeriesModel(lineSeriesModel);
          const lineWidth = index === 3 ? EMPHASIS_LINE_WIDTH : NORMAL_LINE_WIDTH;
          const symbolSize = index === 3 ? MAIN_SCALE : SCALE;
          lineSeriesView.group.childAt(0).eachChild(child => {
            const zrIns = child.childAt(0);
            // 高亮态样式
            zrIns.states.emphasis = {
              ...zrIns.states.emphasis,
              scaleX: symbolSize,
              scaleY: symbolSize,
              style: {
                lineWidth,
              },
            };
          });
        }
      });
    });
  }
  mounted() {
    // 初始化重试次数
    let tryGetDomHeightTimes = 0;
    // 重试次数设定一个最大重试次数
    const TRY_MAX_TIMES = 20;
    // 定时器执行间隔
    const TIMEOUT_TIME = 300;
    this.$nextTick(async () => {
      const chartDom = this.$refs.targetchart as HTMLElement;
      // 如果没有获取到dom的高度则不断重试
      while (!chartDom.clientHeight) {
        tryGetDomHeightTimes++;
        // 如果没有到最大次数就继续获取dom高度
        if (tryGetDomHeightTimes < TRY_MAX_TIMES) {
          // 等待300ms再次获取
          await new Promise(resolve => (this.getChartHightTimeout = setTimeout(resolve, TIMEOUT_TIME)));
        } else {
          // 超出最大次数跳出
          break;
        }
      }
      if (this.getChartHightTimeout) {
        clearTimeout(this.getChartHightTimeout);
        this.getChartHightTimeout = null;
      }
      // 初始化图表
      this.initChart();
    });
  }
  beforeDestroy() {
    clearTimeout(this.getChartHightTimeout);
    this.getChartHightTimeout = null;
  }
}
